import React, { useState, useEffect } from "react";
import { initialShopData } from "../../secondUtils/constants";
import { FaHeartbeat } from "react-icons/fa";
import { MdAddShoppingCart, MdKeyboardDoubleArrowRight } from "react-icons/md";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import allPaths from "../../Config/paths"


const DentalStore = (props) => {
    const history = useHistory()
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const [shopData, setShopData] = useState([]);
    const [sortOrder, setSortOrder] = useState('');

    useEffect(() => {
        let data = [...initialShopData];
        if (sortOrder === 'priceLowToHigh') {
            data.sort((a, b) => a.price - b.price);
        } else if (sortOrder === 'priceHighToLow') {
            data.sort((a, b) => b.price - a.price);
        }

        setShopData(data.slice(0, 10));
    }, [sortOrder]);

    useEffect(() => {
        setShopData(initialShopData.slice(0, 10));
    }, []);
    const handleNavigate = (path) => {
        history.push(path)
    }
    return (
        <div className="main">
            <div className="second-design-service-container">
                <div className="service-top-div">
                    <div>
                        <h1>{selectedLanguage?.txt_dental_store}</h1>
                    </div>
                </div>
                <div>
                    <div className="select-filter-div">
                        <h3>{selectedLanguage?.txt_showing_1_to_10_of_16_results}</h3>
                        <select className="select-filter" value={sortOrder} onChange={e => setSortOrder(e.target.value)}>
                            <option value="">{selectedLanguage?.txt_default}</option>
                            <option value="priceLowToHigh">{selectedLanguage?.txt_price_low_to_high}</option>
                            <option value="priceHighToLow">{selectedLanguage?.txt_price_high_to_low}</option>
                        </select>
                    </div>
                    <div className="shop-container">
                        {shopData?.map((v, i) => (
                            <div key={i}>
                                <div className="shopItem-img-div">
                                    <div className="shopItem-overlap-div">
                                        <div>
                                            <button><MdAddShoppingCart /></button>
                                            <button><FaHeartbeat /></button>
                                        </div>
                                    </div>
                                    <img src={v?.img} alt={v?.name} />
                                </div>
                                <h2>
                                    {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}
                                </h2>
                                <div>{v?.rating}</div>
                                <p>${v.price}.00</p>
                            </div>
                        ))}
                    </div>
                    <div className="prev-next-btn-div">
                        <button className="active_btn" onClick={() => handleNavigate(allPaths?.DENTALSTORE)}>1</button>
                        <button onClick={() => handleNavigate(allPaths?.SHOP)}>2</button>
                        <button onClick={() => handleNavigate(allPaths?.SHOP)}>{selectedLanguage?.txt_next}
                            <MdKeyboardDoubleArrowRight /></button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DentalStore 